




















































import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive } from 'vue-property-decorator';

// Shared types
import { IndoorUnit, System, Texts } from '@coldtec/cos-types';

// Store types
import { CompanyGetter } from '@/store/store.types';

/**
 *  Component that renders the specs that are shown of a system by default.
 */
@Component
export default class SystemSpecsPreview extends Vue {

    @InjectReactive('system')
    private system!: System;

    /**
     *  Used to get all the texts of the company.
     */
    private get companyTexts(): Texts {

        return this.$store.getters[CompanyGetter.TEXTS];

    }

    /**
     *  Used to get the decibel of the inside unit with the
     *  lowest decibel, which should be shown by default.
     */
    private get lowestDecibel(): number {

        let lowest = 0;

        for (const unit of this.system.indoor_units as Array<IndoorUnit>) {

            lowest = lowest === 0 || (unit.noise_level < lowest)
                ? unit.noise_level
                : lowest;

        }

        return lowest;

    }

}
